import React, { useState, useEffect } from "react";
import axios from "axios";
import { API, colors } from "../shared/constants";
import { styles } from "../shared/styles";
import { TabBar } from "../shared/TabBar";
import { isArchivedAccount } from "../shared/utils";
import { AccountFormModal } from "./AccountFormModal";

export function CustomerAccounts({ onSelect }) {
  const userRole = localStorage.getItem("sfp_role");
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [hovered, setHovered] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [tab, setTab] = useState("active");
  const loadAccounts = () => {
    axios
      .get(`${API}/accounts/`)
      .then((res) => {
        setAccounts(res.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };
  useEffect(() => {
    loadAccounts();
  }, []);
  const archivedCount = accounts.filter(isArchivedAccount).length;
  const filtered = accounts.filter(
    (a) =>
      isArchivedAccount(a) === (tab === "archived") &&
      a.account_name.toLowerCase().includes(search.toLowerCase()),
  );
  return (
    <div>
      <div style={styles.topbar}>
        <div style={styles.pageTitle}>Customer Accounts</div>
      </div>
      <TabBar
        tabs={["active", "archived"]}
        tabLabels={{
          active: `Active (${accounts.length - archivedCount})`,
          archived: `Archived (${archivedCount})`,
        }}
        activeTab={tab}
        onSelect={setTab}
      />
      <div style={styles.content}>
        <div style={styles.card}>
          <div style={styles.searchBar}>
            <input
              style={{ ...styles.searchInput, maxWidth: "50%" }}
              placeholder="Search accounts..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            {userRole !== "field_tech" && (
              <button
                style={styles.addButton}
                onClick={() => setShowModal(true)}
              >
                + Add Customer Account
              </button>
            )}
          </div>
          <div style={{ ...styles.tableHeader, gridTemplateColumns: "2fr 1fr 1fr 1fr" }}>
            <div>Account Name</div>
            <div>Tier</div>
            <div>Status</div>
            <div>Annual Value</div>
          </div>
          {loading ? (
            <div style={styles.loading}>Loading...</div>
          ) : (
            filtered.map((account) => (
              <div
                key={account.id}
                style={{
                  ...styles.tableRow(hovered === account.id),
                  gridTemplateColumns: "2fr 1fr 1fr 1fr",
                }}
                onMouseEnter={() => setHovered(account.id)}
                onMouseLeave={() => setHovered(null)}
              >
                <div
                  style={{
                    fontWeight: "500",
                    color: colors.text,
                    cursor: "pointer",
                  }}
                  onClick={() => onSelect(account.id)}
                >
                  {account.account_name}
                </div>
                <div>
                  <span style={styles.tierBadge(account.tier)}>
                    {account.tier.toUpperCase()}
                  </span>
                </div>
                <div>
                  <span style={styles.statusBadge(account.status)}>
                    {account.status.charAt(0).toUpperCase() +
                      account.status.slice(1)}
                  </span>
                </div>
                <div style={{ fontWeight: "600", color: colors.text, fontSize: "14px" }}>
                  ${(parseFloat(account.annual_value) || 0).toLocaleString("en-AU", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </div>
              </div>
            ))
          )}
          <div
            style={{
              ...styles.count,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <span>
              {filtered.length} Customer Account
              {filtered.length !== 1 ? "s" : ""}
            </span>
            <span style={{ fontWeight: "600", color: colors.green }}>
              Value of Contracts: $
              {filtered
                .reduce((sum, a) => sum + (parseFloat(a.annual_value) || 0), 0)
                .toLocaleString("en-AU", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
            </span>
          </div>
        </div>
      </div>
      {showModal && (
        <AccountFormModal
          onClose={() => setShowModal(false)}
          onSave={() => loadAccounts()}
        />
      )}
    </div>
  );
}
